module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp1"
  }), _vm._v(" "), _c('p', {
    staticClass: "FMH"
  }, [_c('a', {
    attrs: {
      "id": "pg_vii"
    }
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("CONTENTS")])])]), _c('a', {
    attrs: {
      "id": "pg_vii"
    }
  }), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "id": "pg_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/foreword"
    }
  }, [_vm._v("Foreword, by Martin J. Sherwin")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction"
    }
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "CPT"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part1"
    }
  }, [_c('span', {
    staticClass: "ePub-SCB"
  }, [_vm._v("PART ONE")]), _c('span', {
    staticClass: "ePub-B"
  }, [_vm._v(": 1945–1949")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1"
    }
  }, [_c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("CHAPTER ONE")]), _vm._v(": "), _c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("David Lilienthal’s Vacation")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter2"
    }
  }, [_c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("CHAPTER TWO")]), _vm._v(": "), _c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("The Maneuvering Begins")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter3"
    }
  }, [_c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("CHAPTER THREE")]), _vm._v(": "), _c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("The Halloween Meeting")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("CHAPTER FOUR")]), _vm._v(": "), _c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("The Secret Debate")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("CHAPTER FIVE")]), _vm._v(": "), _c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("Lost Opportunities")])])]), _vm._v(" "), _c('p', {
    staticClass: "CPT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-SCB"
  }, [_vm._v("PART TWO")]), _c('span', {
    staticClass: "ePub-B"
  }, [_vm._v(": 1950")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("CHAPTER SIX")]), _vm._v(": "), _c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("Fuchs’s Betrayal")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("CHAPTER SEVEN")]), _vm._v(": "), _c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("Fission versus Fusion")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("CHAPTER EIGHT")]), _vm._v(": "), _c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("Teller")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("CHAPTER NINE")]), _vm._v(": "), _c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("Ulam")])])]), _vm._v(" "), _c('p', {
    staticClass: "CPT"
  }, [_c('a', {
    attrs: {
      "id": "pg_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/part3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-SCB"
  }, [_vm._v("PART THREE")]), _c('span', {
    staticClass: "ePub-B"
  }, [_vm._v(": 1951–1952")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("CHAPTER TEN")]), _vm._v(": "), _c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("Teller’s Choice")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("CHAPTER ELEVEN")]), _vm._v(": "), _c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("The Second Lab")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("CHAPTER TWELVE")]), _vm._v(": "), _c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("A New Era")])])]), _vm._v(" "), _c('p', {
    staticClass: "CPT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-SCB"
  }, [_vm._v("PART FOUR")]), _c('span', {
    staticClass: "ePub-B"
  }, [_vm._v(": 1952–1954")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("CHAPTER THIRTEEN")]), _vm._v(": "), _c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("Sailing Close to the Wind")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("CHAPTER FOURTEEN")]), _vm._v(": "), _c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("Strauss Returns")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("CHAPTER FIFTEEN")]), _vm._v(": "), _c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("Two Wild Horses")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("CHAPTER SIXTEEN")]), _vm._v(": "), _c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("The Blank Wall")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("CHAPTER SEVENTEEN")]), _vm._v(": "), _c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("Hoover")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("CHAPTER EIGHTEEN")]), _vm._v(": "), _c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("The Hearing Begins")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("CHAPTER NINETEEN")]), _vm._v(": "), _c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("Smyth")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("CHAPTER TWENTY")]), _vm._v(": "), _c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("Borden")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("CHAPTER TWENTY-ONE")]), _vm._v(": "), _c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("Caesar’s Wife")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("CHAPTER TWENTY-TWO")]), _vm._v(": "), _c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("Do We Really Need Scientists?")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("CHAPTER TWENTY-THREE")]), _vm._v(": "), _c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("Oppenheimer")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("CHAPTER TWENTY-FOUR")]), _vm._v(": "), _c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("We Made It—and We Gave It Away")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/postlude",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("Postlude")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Photographs")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Selected Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef6128c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 75
// module chunks = 0